import { useMemo, useState } from 'react';
import { DataSourcesQueries } from '@frontend/api-data-sources';

export type SourceDropdownFilterOptions = { label: string; value: string }[];

export const useGetSourceDropdownFilterDetails = () => {
  const [selectedSourceIds, setSelectedSourceIds] = useState<string[]>([]);

  const { data, hasMultiplePmsSources } = DataSourcesQueries.useGetAccessibleIntegrations();

  const sourceOptions = useMemo(() => {
    const pmsSources = data?.filter((source) => source.SourceType === 'Integration') || [];
    const options = pmsSources.map((source) => {
      if (!source.SourceID || !source.SourceName) return;
      return { label: source.SourceName, value: source.SourceID };
    });
    return options.filter((option) => !!option);
  }, [data]);

  return {
    hasMultipleSources: hasMultiplePmsSources,
    sourceOptions,
    selectedSourceIds,
    setSelectedSourceIds,
  };
};
